import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <div className="container-fluid  footer-bottom1">
        <div className="d-flex bd-highlight ">
          <Link to={'/terms-condition'}>
            <p className="footer-text-2">
              Terms and Condition
            </p>
          </Link>
          <div className="footer-text-2 d-flex ms-auto bd-highlight">
            <p>All Rights Reserved Copyright© </p>alasab{new Date().getFullYear()}{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
